/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/777/interface/api/cat_18726
 */

import { message } from 'ant-design-vue'
import {
  announcement_center_create_post,
  announcement_center_update_post,
  announcement_center_page_post,
  announcement_center_detail_post,
  announcement_center_export_read_record_post,
  announcement_center_read_record_post,
  announcement_center_update_read_status_post,
  announcement_center_update_status_post,
  announcement_center_read_detail_post
} from 'server/modules/18726'

// 新增公告
export const announcement_center_create_post_ = async function(params) {
  const { success, data, retInfo } = await announcement_center_create_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 修改公告
export const announcement_center_update_post_ = async function(params) {
  const { success, data, retInfo } = await announcement_center_update_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取公告列表
export const announcement_center_page_post_ = async function(params) {
  const { success, data, retInfo } = await announcement_center_page_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取公告明细列表
export const announcement_center_detail_post_ = async function(params) {
  const { success, data, retInfo } = await announcement_center_detail_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 导出阅读记录
export const announcement_center_export_read_record_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await announcement_center_export_read_record_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 阅读记录
export const announcement_center_read_record_post_ = async function(params) {
  const { success, data, retInfo } = await announcement_center_read_record_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 更新已读
export const announcement_center_update_read_status_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await announcement_center_update_read_status_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 修改公告状态
export const announcement_center_update_status_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await announcement_center_update_status_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取公告详情
export const announcement_center_read_detail_post_ = async function(params) {
  const { success, data, retInfo } = await announcement_center_read_detail_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}
